require('./simple-popup.min');

let cat_id = false;

$(document).ready(function () {
    $('a.chooseProject').click(function (e) {
        e.preventDefault();

        $('a.chooseProject').removeClass('active');
        $(this).addClass('active');
        if (cat_id !== $(this).data('cat-id')) {
            $('#chooseProject').addClass('invisible');
            cat_id = $(this).data('cat-id');

            $('a.projectItem').removeClass('active');
            $('.projects-column').closest('.col-6').addClass('d-none');
            $('a.projectItem[data-cat-id=' + cat_id + ']').closest('.col-6').removeClass('d-none');
        }
    });

    // $('a.incentiveItem').click(function (e) {
    //     e.preventDefault();
    //     window.incentive_id = $(this).data('incentive-id');
    //     $('#chooseIncentive').attr('href','/gegevens-invullen/'+window.incentive_id);
    //     $('a.incentiveItem').removeClass('active');
    //     $(this).addClass('active');
    //
    //     $('#chooseIncentive').removeClass('invisible');
    // });
    //
    // $('#chooseIncentive').click(function(e){
    //     e.preventDefault();
    //     // console.log(window.incentive_id);
    //     document.location = '/gegevens-invullen/'+window.incentive_id;
    // });

    $('#header .menu').click(function(e){
        e.preventDefault();
        $(this).toggleClass('toggled');
        $('#menu-wrapper').toggleClass('toggled');
    });

    $('#menu-wrapper a').click(function(e){
        $('#menu-wrapper,#header .menu').toggleClass('toggled');
    });

    $('input[name=incentive],select[name=incentive],select[name="incentive[]"],input[name="incentive[]"]').on('change',function(){

        if($(this).parent().find(':checked').attr('data-type') == '1') {
            $('.show-on-incentive').removeClass('d-none');
        } else {
            $('.show-on-incentive').addClass('d-none');
        }
    });

    $('input[name=product]').on('change',function(){
        showIncentives();
    });

    $('input[name=zipcode],input[name=houseNumber],input[name=houseNumberAddition]').on('blur',function(){

        var zipcode = $('input[name=zipcode]').val();
        var housenr = $('input[name=houseNumber]').val();
        var housenr_ext = $('input[name=houseNumberAddition]').val();

        var errors = false;
        if($('input[name=zipcode]').hasClass('error')) { return true; }
        else if($('input[name=houseNumber]').hasClass('error')) { return true; }
        else if($('input[name=houseNumberAddition]').hasClass('error')) { return true; }

        if(zipcode != '' && housenr != '') {

          $('.loading-icon i').addClass('active');

          // Original script, modified fields and returns only.
          $.ajax({
               type: "GET",
               url: encodeURI('/zipcode/'+$.trim(zipcode).toUpperCase().replace(/\s/g, '')+'/'+$.trim(housenr).toUpperCase().replace(/\s/g, '')+'/'+$.trim(housenr_ext)),
               error: function(jqXHR, textStatus, errorThrown) {
                    console.log('jqXHR: '+jqXHR);
                    console.log('textStatus: '+textStatus);
                    console.log('errorThrown: '+errorThrown);

                    $('.loading-icon i').removeClass('active');
                    $('input[name=street]').val('Adres ophalen niet gelukt.');

               },
               success: function(data)
               {
                    if(data == 'error') {
                        $('input[name=street]').val('Adres ophalen niet gelukt.');
                        $('input[name=city]').val('Adres ophalen niet gelukt.');
                    } else {
                        $('input[name=street]').val(data.street);
                        $('input[name=city]').val(data.city);
                    }

                    $('.loading-icon i').removeClass('active');
               }
          });

      } else {
          $('input[name=street]').val('');
          $('input[name=city]').val('');
      }


    });

    // FAQ
    $('#faq .faq-item .faq-title').click(function(){

        if(!$(this).parent().hasClass('toggled')) {
            $('#faq .faq-item').removeClass('toggled');
            $('#faq .faq-item .faq-content').slideUp();
            $(this).parent().addClass('toggled');
            $(this).parent().find('.faq-content').slideDown();
        } else {
            $(this).parent().removeClass('toggled');
            $(this).parent().find('.faq-content').slideUp();
        }
    });

    // Popups
    $(".has-popup").on("click", function(e) {
        e.preventDefault();
        console.log('test');
        var popup = $(this).attr('data-popup');
        $(this).simplePopup({ type: "html", htmlSelector: ".popup_"+popup });
    });



    // Ajax
    $('._ajax-product').on('change',function(){
        var Val = $(this).find('option:checked');
        var Type = Val.attr('data-product_type');
        var Val = Val.val();

        var Type = Type == '16384' ? 'config' : 'bundle';

        var IncentiveID = $(this).attr('data-incentive-id');
        var Parent = $(this).parent();

        Parent.addClass('_loading');
        // Parent.find('._ajax-child').addClass('d-none');
        Parent.find('._ajax-child').prop('readonly',true).removeClass('_no-results');
        Parent.find('._ajax-child option[value!=""]').remove();
        var backendID = $(this).find('option:checked').attr('data-custom-id');


        if(Val != '') {
            
            $.ajax({
                url: '/ajax/getAvailableProducts',
                type: 'POST',
                dataType: "json",
                data: {ProductID: Val,Type: Type},
                success: function success(result) {
                    
                    // TODO: Append results into options.
                if(Type == 'config' || Type == 'combi') { 

                    if(Object.keys(result.products.Configurable.Children).length > 0 && Object.keys(result.availability).length > 0) {

                        $.each(result.products.Configurable.Children, function(i, child) {
                            var unavailable = !result.availability || result.availability[child.ProductID].ProductStatus == 0 ? true : false;
console.log(result.availability[child.ProductID]);                            
var unavailable = !result.availability || !result.availability[child.ProductID].Delivery.IsAvailable ? true : false;
//console.log(result.availability[child.ID]);
			    Parent.find('._ajax-child').append('<option value="'+child.ProductID+'" '+(unavailable ? 'disabled' : '') +' data-custom-id="'+child.Properties.backend_id+'">'+child.Value+' '+(unavailable ? '(niet beschikbaar)' : '')+'</option>');
                        });

                    } else {
                        Parent.find('._ajax-child').addClass('_no-results');
                    }
                } else if(Type == 'bundle' || Type == 'combi') {

                    if(Object.keys(result.products).length > 0 && Object.keys(result.availability).length > 0) {

                        // console.log(result.products.Products);
                        $.each(result.products.Products, function(i, child) {
                            //var unavailable = !result.availability || result.availability[child.ID].ProductStatus == 0 ? true : false;
                            var unavailable = !result.availability || !result.availability[child.ID][Delivery].IsAvailable ? true : false;

			    Parent.find('._ajax-child').append('<option value="'+child.ID+'" '+(unavailable ? 'disabled' : '') +' data-custom-id="'+backendID+'" data-bundle-custom-id="'+child.Content.backend_id+'" data-bundle-id="'+child.ID+'">'+child.Content.backend_id+' '+(unavailable ? '(niet beschikbaar)' : '')+'</option>');
                        });

                    } else {
                        Parent.find('._ajax-child').addClass('_no-results');
                    }
                }

                    Parent.removeClass('_loading');

                    // $('._ajax-child').removeClass('d-none');
                    Parent.find('._ajax-child').removeAttr('readonly');
    
                  },
                    error: function (err) {
                        
                        console.log('error');
                  }
              });

        } else {
            // No value
            Parent.removeClass('_loading');
        }
        
    });

    $('._ajax-product,._ajax-child').on('change',function(){
        var Parent = $(this).parent();
        var Product = Parent.find('._ajax-product option:checked');
        var ValProduct = Product.val();

        var Child = Parent.find('._ajax-child option:checked');
        var ValChild = Child.val();

        var CurrentIncentives = $('._ajax-product option:checked:not([value=""]').length;
        var CurrentChilds = $('._ajax-child option:checked:not([value=""]').length;

        window.NumIncentives = $('input[name="num_incentives"]').val() == '0' ? $('._ajax-product:visible').length : $('input[name="num_incentives"]').val();


        if((CurrentChilds == window.NumIncentives) && (CurrentIncentives <= window.NumIncentives)) {
            $('._enterDetails-submit').prop('disabled',false);
        } else {
            $('._enterDetails-submit').prop('disabled',true);
        }

        Parent.find('.form-check:first-child input[name^="incentive"]').prop('checked',true);

        Parent.find('._ajax-product-name').val(Product.text());
        Parent.find('._ajax-child-name').val(Child.text());
        Parent.find('._ajax-custom-id').val(Child.attr('data-custom-id'));
        Parent.find('._ajax-bundle-custom-id').val(Child.attr('data-bundle-custom-id'));
        Parent.find('._ajax-bundle-id').val(Child.attr('data-bundle-id'));
    });



    $('.carousel').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        // variableWidth: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
        ]
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.sortable tbody').sortable({
        'containment': 'parent',
        'revert': true,
        start: function(event, ui) {
            $('.sortable tbody tr').each(function() {
                $(this).attr('data-old-position',$(this).index() + 1);
            });
        },
        update: function(event, ui) {
            var model = $('.sortable').attr('data-model');

            $('.sortable tbody tr').each(function() {
                var vehicleID = $(this).attr('data-id');
                var newIndex = $(this).index() + 1;
                var oldIndex = $(this).attr('data-old-position');
                $(this).attr('data-new-position',newIndex);

                if(newIndex != oldIndex) {
                    $.ajax({
                        // url: '/dashboard/vehicles/reposition/'+vehicleID,
                        url: '/dashboard/'+model+'/reposition/'+vehicleID,
                        type: 'PUT',
                        data: { oldPosition: oldIndex, newPosition: newIndex },
                        success: function(result) {
                            if(result == 'true') {
                            } else {
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Oops...',
                                  text: 'Something went wrong!',
                                  footer: 'Please contact your webmaster and send the following code: CODE - FALSE-REPOSITION-VEHICLE-'+vehicleID,
                              });
                            }
                        },
                        error: function(jqXHR, exception) {
                            Swal.fire({
                              icon: 'error',
                              title: 'Oops...',
                              text: 'Something went wrong!',
                              footer: 'Please contact your webmaster and send the following code: CODE-REPOSITION - '+jqXHR.status+' EXCEPTION - '+exception,
                          });
                        }
                    });
                }
            });

        }
    });

});


function showIncentives() {
    var product_id = $('input[name=product]:checked').attr('data-product_id');

    $('.show-on-products').addClass('d-none');
    $('.show-on-incentive').addClass('d-none');


    
    var check_ts = $('.datepicker').datepicker({ dateFormat: 'yy-mm-dd' }).val();

    if(check_ts == '') {
        $('.show-on-products').addClass('d-none');
    }

    $('input[name^=incentive],select[name=incentive]').each(function(){

        $(this).prop('checked',false);

        var Parent = $(this).parent().hasClass('form-check-inner') ? $(this).parent().parent() : $(this).parent();
        Parent.addClass('d-none');

        var product_ids = $(this).attr('data-products');

        if(product_ids != '') {

            var product_ids = product_ids.split(',');

            // If incentive connected to product
            if(product_ids.includes(product_id) && check_ts != '') {
                $('.show-on-products').removeClass('d-none');

                var start_ts = $(this).attr('data-start');
                var end_ts = $(this).attr('data-end');

                var d1 = start_ts.split("-");
                var d2 = end_ts.split("-");
                var c = check_ts.split("-");

                var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
                var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
                var check = new Date(c[2], parseInt(c[1])-1, c[0]);

                if(start_ts != '' && end_ts != '') {
                    // If looptijd
                    console.log(from);
                    console.log(to);
                    console.log(check);

                    if(check >= from && check <= to) {
                        Parent.removeClass('d-none');
                        $('.show-on-products').removeClass('d-none');
                    }

                // Only start date
                } else if(start_ts != '' && end_ts == '') {

                    if(check >= from) {
                        Parent.removeClass('d-none');
                        $('.show-on-products').removeClass('d-none');
                    }

                // Only end date
                } else if(start_ts == '' && end_ts != '') {

                    if(check <= to) {
                        Parent.removeClass('d-none');
                        $('.show-on-products').removeClass('d-none');
                    }

                }

            } else {
                // $('.show-on-products').addClass('d-none');
                $(this).prop('checked',false);
                Parent.addClass('d-none');
            }
        }

    });


    if(!$('.show-on-products .form-check:visible,.show-on-products .form-select:visible').length) {
        $('.show-on-products .empty').removeClass('d-none');
    } else {
        $('.show-on-products .empty').addClass('d-none');
    }

    window.NumIncentives = $('input[name="num_incentives"]').val() == '0' ? $('._ajax-product:visible').length : $('input[name="num_incentives"]').val();

jQuery('[name="incentive[]"]:visible').each(function() {

    jQuery(this).rules('add', {
        minlength: window.NumIncentives
    });
});

}


$( function() {
    $.datepicker.setDefaults(
      $.extend(
        {'dateFormat':'dd-mm-yy'},
        $.datepicker.regional['nl']
      )
    );

    $('.datepicker').on('change',function(){
        showIncentives();
    });

    $( ".datepicker" ).datepicker({
        dateFormat: 'dd-mm-yy',
        firstDay: 1,
        onSelect: function(dateText, inst) {

            var check_ts = dateText;

            showIncentives();

            // $('input[name=incentive]').each(function(){
            //
            //     var start_ts = $(this).attr('data-start');
            //     var end_ts = $(this).attr('data-end');
            //
            //     var d1 = start_ts.split("-");
            //     var d2 = end_ts.split("-");
            //     var c = check_ts.split("-");
            //
            //     var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
            //     var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
            //     var check = new Date(c[2], parseInt(c[1])-1, c[0]);
            //
            //     // If looptijd
            //     if(start_ts != '' && end_ts != '') {
            //
            //         if(check > from && check < to) {
            //             $(this).parent().removeClass('d-none');
            //         }
            //
            //     // Only start date
            //     } else if(start_ts != '' && end_ts == '') {
            //
            //         if(check > from) {
            //             $(this).parent().removeClass('d-none');
            //         }
            //
            //     // Only end date
            //     } else if(start_ts == '' && end_ts != '') {
            //
            //         if(check < to) {
            //             $(this).parent().removeClass('d-none');
            //         }
            //
            //     }
            //
            //     // console.log(check > from && check < to)
            //
            // });

       }
    });
  } );
